<app-filter-panel [quickSearchFilter]="filters.extenOrDescription.filters[0]" quickSearchPlaceholder="Código" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
  <span class="w-full input-field p-input-icon-right">
      <input pInputText placeholder="Código" [(ngModel)]="filters.extenOrDescription.filters[0].value" (keydown.enter)="search()"
          class="w-full" />
      <i *ngIf="filters.extenOrDescription.filters[0].value" class="pi pi-times cursor-pointer"
          (click)="filters.extenOrDescription.filters[0].value = null; search()"></i>
  </span>
</div>
-->

<p-table #grid [value]="extensions" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
  [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
  [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="header" let-columns>
      <tr>            
        <th pSortableColumn="Exten">Extensión <p-sortIcon field="Exten"></p-sortIcon></th>
        <th pSortableColumn="User">Usuario <p-sortIcon field="User"></p-sortIcon></th>
        <th>Estado</th>
        <th width="100"></th>
      </tr>
  </ng-template>
  <ng-template pTemplate="body" let-extension let-columns="columns">
      <tr>
          <td>{{extension.exten}}</td>
          <td [class.text-danger]="!extension.user?.active">
            {{extension.description}}
          </td>
          <td>
            <p-badge [value]="extension.status" [severity]="extension.severity"></p-badge>
          </td>
          <td>
            <div class="flex gap-2 justify-content-end">
              <p-button *ngIf="!extension.user?.active" (click)="delete(extension)" [rounded]="true" [text]="false"
                  severity="danger"><i class="pi pi-trash"></i></p-button>
              <p-button (click)="edit(extension.id)" [rounded]="true" [text]="false"><i class="pi pi-eye"></i></p-button>
            </div>
          </td>
      </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="3">        
           No se ha encontrado equipamiento
        </td>
      </tr>
    </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>